export default "__VITE_ASSET__CaOeTF4B__"